import {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {handleErrorResponse, handleSessionExp, handleError} from '@/businesses/apiBusiness';
import apiObserver from '@/observers/apiObserver';

// Our hook
const useAPIObserver = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const onHandleSessionExp = (...args) => dispatch(handleSessionExp(...args));
    const onHandleError = (...args) => dispatch(handleError(...args));
    const onHandleErrorResponse = (...args) => dispatch(handleErrorResponse(...args));

    apiObserver.add.authExpHandler(onHandleSessionExp);
    apiObserver.add.errorHandler(onHandleError);
    apiObserver.add.errorResponseHandler(onHandleErrorResponse);
    return () => {
      apiObserver.remove.authExpHandler(onHandleSessionExp);
      apiObserver.remove.errorHandler(onHandleError);
      apiObserver.remove.errorResponseHandler(onHandleErrorResponse);
    };
  }, [dispatch]);

  return null;
};

export default useAPIObserver;
